import {Dialog} from '@primer/react'
import {useMemo} from 'react'

import {DialogType} from '../state-providers/modals/add-field-modal-state-provider'
import {useAddIssueFieldsDialog, type UseAddIssueFieldsDialogProps} from './use-add-issue-fields-dialog'
import {useAddProjectFieldDialog, type UseAddProjectFieldDialogProps} from './use-add-project-field-dialog'

type AddFieldsDialogProps = Omit<UseAddProjectFieldDialogProps & UseAddIssueFieldsDialogProps, 'isOpen'> & {
  dialogType: DialogType
}

export function AddFieldsDialog(props: AddFieldsDialogProps) {
  const issueFieldsDialogProps = useAddIssueFieldsDialog({
    isOpen: props.dialogType === DialogType.IssueFields,
    setOpen: props.setOpen,
    onSave: props.onSave,
    issueFields: props.issueFields,
    openAddColumnDialog: props.openAddColumnDialog,
    issueFieldsLoading: props.issueFieldsLoading,
    onSelectFieldWithCollision: props.onSelectFieldWithCollision,
    selectedFieldIds: props.selectedFieldIds,
    setSelectedFieldIds: props.setSelectedFieldIds,
  })
  const projectFieldDialogProps = useAddProjectFieldDialog({
    isOpen: props.dialogType === DialogType.AddColumn,
    setOpen: props.setOpen,
    onSave: props.onSave,
    limitedTypes: props.limitedTypes,
    onBack: props.onBack,
  })

  const dialogProps = useMemo(
    () => (props.dialogType === DialogType.AddColumn ? projectFieldDialogProps : issueFieldsDialogProps),
    [props.dialogType, issueFieldsDialogProps, projectFieldDialogProps],
  )

  return <Dialog height="auto" width="large" {...dialogProps} />
}

try{ AddFieldsDialog.displayName ||= 'AddFieldsDialog' } catch {}